import React from 'react';
import { CountdownBanner } from './components/CountdownBanner';
import { HeroSection } from './components/HeroSection';
import { SalesContent } from './components/SalesContent';
import { FeaturesSection } from './components/FeaturesSection';
import { MethodSection } from './components/MethodSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-cream-light font-sans selection:bg-brand-orange/30 selection:text-brand-navy" data-id="element-0">
      <CountdownBanner data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SalesContent data-id="element-4" />
        <FeaturesSection data-id="element-5" />
        <MethodSection data-id="element-6" />
        <FAQSection data-id="element-7" />
        <PricingSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}